import { useFragment as useApolloFragment } from '@apollo/client/react';

import type { ReportComponentProps } from '@modules/_shared/components/report-editor/ReportEditorContext';
import { STEP_PROPERTY_DETAILS_FRAGMENT } from '@modules/reports/cma-reports/cmaReportsQueries';
import StepPropertyDetails from '@modules/reports/shared/StepPropertyDetails';
import { useUpdateCmaReport } from '@modules/reports/shared/utils';

const StepPropertyDetailsCMA = (props: ReportComponentProps) => {
  const { reportId: cmaReportId } = props;
  const [updateCmaReport, updating] = useUpdateCmaReport(
    cmaReportId,
    'page-property',
  );

  const { data } = useApolloFragment({
    fragment: STEP_PROPERTY_DETAILS_FRAGMENT,
    fragmentName: 'StepPropertyDetails',
    from: {
      __typename: 'cma_reports',
      id: cmaReportId,
    },
  });

  return (
    <StepPropertyDetails
      propertyId={data?.property?.id}
      onPropertyUpdate={() => updateCmaReport({})}
      step={props.step}
      setStep={props.setStep}
      updating={updating}
    />
  );
};

export default StepPropertyDetailsCMA;
